export const TOOLBAR_HEIGHT = 48;
export const SIDEBAR_WIDTH = 80;
